export const TOP_UP_PAGE_TITLE =
  "Tính năng quản lý quá trình sử dụng dịch vụ của người chơi: Ghi nhận thẻ nạp, thời gian, mệnh giá của người chơi khi nạp tiền ảo trong trò chơi";

export const TOP_UP_METHODS = {
  BANK: "Ngân hàng",
  CARD: "Thẻ cào",
  WALLET: "Ví điện tử",
  TRANSFER: "Chuyển khoản",
};

export const TOP_UP_STATUSES = {
  COMPLETED: "Thành công",
  PENDING: "Đang xử lý",
  FAILED: "Thất bại",
};

export const TOP_UP_ACTIONS = {
  APPROVE: "Chấp nhận",
  REJECT: "Reject",
  REVIEW: "Review",
};

export const TOP_UP_TABLE_COLUMNS = [
  { name: "CharacterName", label: "Nhân vật" },
  { name: "Method", label: "Phương thức" },
  { name: "PaymentCode", label: "Mã thanh toán" },
  { name: "Amount", label: "Số tiền" },
  { name: "Code", label: "Mã" },
  { name: "Status", label: "Trạng thái" },
  { name: "Action", label: "Hoạt động" },
  { name: "CreatedDate", label: "Ngày tạo" },
];

export const TOP_UP_FAKE_DATA = [
  {
    id: 1,
    CharacterName: "accno01",
    Method: TOP_UP_METHODS.BANK,
    PaymentCode: "0012",
    Amount: 10000,
    Code: "",
    Status: TOP_UP_STATUSES.COMPLETED,
    Action: TOP_UP_ACTIONS.APPROVE,
    CreatedDate: "2025-10-21T10:40:39+07:00",
  },
  {
    id: 2,
    CharacterName: "accno02",
    Method: TOP_UP_METHODS.BANK,
    PaymentCode: "0015",
    Amount: 50000,
    Code: "",
    Status: TOP_UP_STATUSES.COMPLETED,
    Action: TOP_UP_ACTIONS.APPROVE,
    CreatedDate: "2025-10-22T09:15:20+07:00",
  },
  {
    id: 3,
    CharacterName: "kiemvan88",
    Method: TOP_UP_METHODS.BANK,
    PaymentCode: "0014",
    Amount: 100000,
    Code: "",
    Status: TOP_UP_STATUSES.COMPLETED,
    Action: TOP_UP_ACTIONS.APPROVE,
    CreatedDate: "2025-10-22T14:05:11+07:00",
  },
  {
    id: 4,
    CharacterName: "thanhphong",
    Method: TOP_UP_METHODS.BANK,
    PaymentCode: "0013",
    Amount: 20000,
    Code: "",
    Status: TOP_UP_STATUSES.COMPLETED,
    Action: TOP_UP_ACTIONS.APPROVE,
    CreatedDate: "2025-10-23T08:30:00+07:00",
  },
  {
    id: 5,
    CharacterName: "tuyetnhi",
    Method: TOP_UP_METHODS.BANK,
    PaymentCode: "0011",
    Amount: 200000,
    Code: "",
    Status: TOP_UP_STATUSES.COMPLETED,
    Action: TOP_UP_ACTIONS.APPROVE,
    CreatedDate: "2025-10-23T16:48:33+07:00",
  },
  {
    id: 6,
    CharacterName: "hoalong",
    Method: TOP_UP_METHODS.BANK,
    PaymentCode: "0010",
    Amount: 10000,
    Code: "",
    Status: TOP_UP_STATUSES.COMPLETED,
    Action: TOP_UP_ACTIONS.APPROVE,
    CreatedDate: "2025-10-24T10:20:18+07:00",
  },
  {
    id: 7,
    CharacterName: "bangtam",
    Method: TOP_UP_METHODS.BANK,
    PaymentCode: "0009",
    Amount: 50000,
    Code: "",
    Status: TOP_UP_STATUSES.COMPLETED,
    Action: TOP_UP_ACTIONS.APPROVE,
    CreatedDate: "2025-10-24T19:55:07+07:00",
  },
  {
    id: 8,
    CharacterName: "accno08",
    Method: TOP_UP_METHODS.BANK,
    PaymentCode: "0008",
    Amount: 30000,
    Code: "",
    Status: TOP_UP_STATUSES.COMPLETED,
    Action: TOP_UP_ACTIONS.APPROVE,
    CreatedDate: "2025-10-25T11:12:45+07:00",
  },
];
